import { Paper, Typography, Box, Chip, Alert } from '@mui/material';
import {
  CheckCircle,
  HourglassEmpty,
  Cancel,
  Business,
} from '@mui/icons-material';

const VolunteerStatusCard = ({ organizationName, status }) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'active':
        return {
          label: 'Approved',
          color: 'success',
          icon: <CheckCircle />,
          severity: 'success',
          message: 'Your account has been approved! You can now sign up for events and track your volunteer hours.',
        };
      case 'pending':
        return {
          label: 'Pending Approval',
          color: 'warning',
          icon: <HourglassEmpty />,
          severity: 'warning',
          message: 'Your account is pending approval from the organization admin. You\'ll be notified once approved and can then start signing up for events.',
        };
      case 'rejected':
        return {
          label: 'Not Approved',
          color: 'error',
          icon: <Cancel />,
          severity: 'error',
          message: 'Your volunteer application was not approved. Please contact the organization admin for more information.',
        };
      default:
        return {
          label: 'Unknown Status',
          color: 'default',
          icon: <HourglassEmpty />,
          severity: 'info',
          message: 'Status unknown. Please contact the organization admin.',
        };
    }
  };

  const config = getStatusConfig();

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 3,
        borderLeft: 4,
        borderColor: `${config.color}.main`,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2 }}>
        <Box
          sx={{
            p: 1.5,
            borderRadius: 2,
            bgcolor: `${config.color}.lighter`,
            color: `${config.color}.main`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Business sx={{ fontSize: 32 }} />
        </Box>

        <Box sx={{ flex: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
            <Typography variant="h6" fontWeight="bold">
              {organizationName}
            </Typography>
            <Chip
              icon={config.icon}
              label={config.label}
              color={config.color}
              size="small"
              sx={{ fontWeight: 'medium' }}
            />
          </Box>

          {status !== 'active' && (
            <Alert severity={config.severity} sx={{ mt: 2 }}>
              {config.message}
            </Alert>
          )}
        </Box>
      </Box>
    </Paper>
  );
};

export default VolunteerStatusCard;
